import type { Slot } from "@medplum/fhirtypes";
import { BOOKED_SLOT_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Slot resource changes via WebSocket
 * and updates the booked-slot TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useBookedSlotSubscription = createSubscriptionHook<Slot>("Slot", BOOKED_SLOT_COLLECTION_NAME);
